module.exports = __webpack_public_path__ + "media/blog/left-323c37fc.png";